import React from 'react';
import {
	ExperienceStart,
	ExperienceSuccess,
	useExperienceFail,
} from '@atlassian/jira-experience-tracker';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';

const VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';

type VersionRelatedWorkExperienceStartProps = {
	experienceId: string;
};

export const VersionRelatedWorkExperienceStart = ({
	experienceId,
}: VersionRelatedWorkExperienceStartProps) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={VERSION_RELATED_WORK_EXPERIENCE_NAME}
			analyticsSource="versionDetails"
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const useViewVersionRelatedWorkExperienceFail = (): ReturnType<typeof useExperienceFail> =>
	useExperienceFail({
		experience: VERSION_RELATED_WORK_EXPERIENCE_NAME,
	});

export const VersionRelatedWorkExperienceSuccessTracker = () => (
	<ExperienceSuccess experience={VERSION_RELATED_WORK_EXPERIENCE_NAME} />
);
